import chmln from '@chamaeleonidae/chmln';
import { CHAMELEON_API_KEY } from '@/configs';
import { CHAMELEON_FAST_URL } from './constant';

export const initializeChameleon = (): void => {
  if (!CHAMELEON_API_KEY) return;

  chmln.init(CHAMELEON_API_KEY, { fastUrl: CHAMELEON_FAST_URL });
};
